/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * dhl-extra
 * OpenAPI spec version: 1.0.0-20260821-211858-d8cc0458
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import { useMutator } from '../../useMutator';
export interface ActionAdminDetails {
  actionId: string;
  title: string;
  description: string;
  contentId: string;
  actionType: string;
  type: ActionType;
  startAt: string;
  endAt: string;
  createdAt: string;
  updatedAt: string;
  allowSubscribe: boolean;
  reward: Reward;
  goalPoints?: number;
  quiz?: QuizSetup;
  termsAndConditions?: TermsAndConditions;
}

export interface ActionDetail {
  actionId: string;
  title: string;
  description: string;
  contentId: string;
  actionType: string;
  type: ActionType;
  startAt: string;
  endAt: string;
  createdAt: string;
  updatedAt: string;
  isSubscribed: boolean;
  allowSubscribe: boolean;
  reward: Reward;
  goalPoints: number;
  quiz?: SingleLanguageQuiz;
  termsAndConditions?: SingleLanguageTermsAndConditions;
}

export type ActionType = MarketingSettingEnabled | OneOff | Quiz;

export interface ActionUpdate {
  title: string;
  description: string;
  contentId: string;
  actionType: string;
  startAt: string;
  endAt: string;
  allowSubscribe: boolean;
  goalPoints?: number;
  reward: Reward;
  quiz?: QuizSetup;
  termsAndConditions?: TermsAndConditions;
}

export interface ActionsEnabled {
  isEnabled: boolean;
}

export interface Answer {
  key: string;
  values?: LanguageString[];
}

export type DiscountCodeRewardType = typeof DiscountCodeRewardType[keyof typeof DiscountCodeRewardType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscountCodeRewardType = {
  DiscountCodeReward: 'DiscountCodeReward',
} as const;

export interface DiscountCodeReward {
  discountPercent: number;
  daysValid: number;
  type: DiscountCodeRewardType;
}

export interface HMacAuthToken {
  payload: string;
}

export interface LanguageLink {
  language: string;
  link: string;
}

export interface LanguageString {
  language: string;
  value: string;
}

export type ManualRewardType = typeof ManualRewardType[keyof typeof ManualRewardType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManualRewardType = {
  ManualReward: 'ManualReward',
} as const;

export interface ManualReward {
  type: ManualRewardType;
}

export type MarketingSettingEnabledType = typeof MarketingSettingEnabledType[keyof typeof MarketingSettingEnabledType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketingSettingEnabledType = {
  MarketingSettingEnabled: 'MarketingSettingEnabled',
} as const;

export interface MarketingSettingEnabled {
  milestone: boolean;
  type: MarketingSettingEnabledType;
}

export type OneOffType = typeof OneOffType[keyof typeof OneOffType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OneOffType = {
  OneOff: 'OneOff',
} as const;

export interface OneOff {
  milestone: boolean;
  type: OneOffType;
}

export type QuizType = typeof QuizType[keyof typeof QuizType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuizType = {
  Quiz: 'Quiz',
} as const;

export interface Quiz {
  milestone: boolean;
  type: QuizType;
}

export interface QuizSetup {
  question?: LanguageString[];
  answers?: Answer[];
}

export type Reward = DiscountCodeReward | ManualReward;

export interface SingleLanguageAnswer {
  key: string;
  value: string;
}

export interface SingleLanguageQuiz {
  question: string;
  answers?: SingleLanguageAnswer[];
}

export interface SingleLanguageTermsAndConditions {
  mustAcknowledge: boolean;
  link: string;
}

export interface SubscribeRequest {
  quizAnswer?: string;
}

export interface TermsAndConditions {
  mustAcknowledge: boolean;
  links?: LanguageLink[];
}

export interface UpdateMarketingSetting {
  wantsNewsAndPromotions?: boolean;
  countries?: string[];
}

export interface UserOptInSettings {
  optIn: boolean;
}

export type GetLoyaltyActionsActionidParams = {
language?: string;
};

export type GetActionsActionidParams = {
language?: string;
};

export type GetLoyaltyActionsParams = {
language?: string;
};

export type GetActionsParams = {
language?: string;
};

export const useGetLoyaltyActionsAdminHook = () => {
        const getLoyaltyActionsAdmin = useMutator<ActionAdminDetails[]>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getLoyaltyActionsAdmin(
          {url: `/loyalty-actions/admin`, method: 'GET', signal
    },
          );
        }, [getLoyaltyActionsAdmin])
      }
    

export const getGetLoyaltyActionsAdminQueryKey = () => {
    return [`/loyalty-actions/admin`] as const;
    }

    
export const useGetLoyaltyActionsAdminQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>, TError = string>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoyaltyActionsAdminQueryKey();

  const getLoyaltyActionsAdmin =  useGetLoyaltyActionsAdminHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>> = ({ signal }) => getLoyaltyActionsAdmin(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoyaltyActionsAdminQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>>
export type GetLoyaltyActionsAdminQueryError = string


export function useGetLoyaltyActionsAdmin<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>, TError = string>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyActionsAdmin<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>, TError = string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyActionsAdmin<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>, TError = string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLoyaltyActionsAdmin<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>, TError = string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLoyaltyActionsAdminQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostLoyaltyActionsAdminHook = () => {
        const postLoyaltyActionsAdmin = useMutator<ActionAdminDetails>();

        return useCallback((
    actionUpdate: ActionUpdate,
 signal?: AbortSignal
) => {
        return postLoyaltyActionsAdmin(
          {url: `/loyalty-actions/admin`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: actionUpdate, signal
    },
          );
        }, [postLoyaltyActionsAdmin])
      }
    


export const usePostLoyaltyActionsAdminMutationOptions = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostLoyaltyActionsAdminHook>>>, TError,{data: ActionUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostLoyaltyActionsAdminHook>>>, TError,{data: ActionUpdate}, TContext> => {

const mutationKey = ['postLoyaltyActionsAdmin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postLoyaltyActionsAdmin =  usePostLoyaltyActionsAdminHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostLoyaltyActionsAdminHook>>>, {data: ActionUpdate}> = (props) => {
          const {data} = props ?? {};

          return  postLoyaltyActionsAdmin(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostLoyaltyActionsAdminMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostLoyaltyActionsAdminHook>>>>
    export type PostLoyaltyActionsAdminMutationBody = ActionUpdate
    export type PostLoyaltyActionsAdminMutationError = string | string

    export const usePostLoyaltyActionsAdmin = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostLoyaltyActionsAdminHook>>>, TError,{data: ActionUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostLoyaltyActionsAdminHook>>>,
        TError,
        {data: ActionUpdate},
        TContext
      > => {

      const mutationOptions = usePostLoyaltyActionsAdminMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetAdminActionsHook = () => {
        const getAdminActions = useMutator<ActionAdminDetails[]>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getAdminActions(
          {url: `/admin/actions`, method: 'GET', signal
    },
          );
        }, [getAdminActions])
      }
    

export const getGetAdminActionsQueryKey = () => {
    return [`/admin/actions`] as const;
    }

    
export const useGetAdminActionsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>, TError = string>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminActionsQueryKey();

  const getAdminActions =  useGetAdminActionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>> = ({ signal }) => getAdminActions(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminActionsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>>
export type GetAdminActionsQueryError = string


export function useGetAdminActions<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>, TError = string>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminActions<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>, TError = string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminActions<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>, TError = string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminActions<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>, TError = string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAdminActionsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostAdminActionsHook = () => {
        const postAdminActions = useMutator<ActionAdminDetails>();

        return useCallback((
    actionUpdate: ActionUpdate,
 signal?: AbortSignal
) => {
        return postAdminActions(
          {url: `/admin/actions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: actionUpdate, signal
    },
          );
        }, [postAdminActions])
      }
    


export const usePostAdminActionsMutationOptions = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAdminActionsHook>>>, TError,{data: ActionUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAdminActionsHook>>>, TError,{data: ActionUpdate}, TContext> => {

const mutationKey = ['postAdminActions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postAdminActions =  usePostAdminActionsHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostAdminActionsHook>>>, {data: ActionUpdate}> = (props) => {
          const {data} = props ?? {};

          return  postAdminActions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminActionsMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostAdminActionsHook>>>>
    export type PostAdminActionsMutationBody = ActionUpdate
    export type PostAdminActionsMutationError = string | string

    export const usePostAdminActions = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAdminActionsHook>>>, TError,{data: ActionUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostAdminActionsHook>>>,
        TError,
        {data: ActionUpdate},
        TContext
      > => {

      const mutationOptions = usePostAdminActionsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetLoyaltyActionsAdminActionidHook = () => {
        const getLoyaltyActionsAdminActionid = useMutator<ActionAdminDetails>();

        return useCallback((
    actionId: string,
 signal?: AbortSignal
) => {
        return getLoyaltyActionsAdminActionid(
          {url: `/loyalty-actions/admin/${actionId}`, method: 'GET', signal
    },
          );
        }, [getLoyaltyActionsAdminActionid])
      }
    

export const getGetLoyaltyActionsAdminActionidQueryKey = (actionId?: string,) => {
    return [`/loyalty-actions/admin/${actionId}`] as const;
    }

    
export const useGetLoyaltyActionsAdminActionidQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>, TError = string | string>(actionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoyaltyActionsAdminActionidQueryKey(actionId);

  const getLoyaltyActionsAdminActionid =  useGetLoyaltyActionsAdminActionidHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>> = ({ signal }) => getLoyaltyActionsAdminActionid(actionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(actionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoyaltyActionsAdminActionidQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>>
export type GetLoyaltyActionsAdminActionidQueryError = string | string


export function useGetLoyaltyActionsAdminActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>, TError = string | string>(
 actionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyActionsAdminActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>, TError = string | string>(
 actionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyActionsAdminActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>, TError = string | string>(
 actionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLoyaltyActionsAdminActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>, TError = string | string>(
 actionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsAdminActionidHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLoyaltyActionsAdminActionidQueryOptions(actionId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePutLoyaltyActionsAdminActionidHook = () => {
        const putLoyaltyActionsAdminActionid = useMutator<ActionAdminDetails>();

        return useCallback((
    actionId: string,
    actionUpdate: ActionUpdate,
 ) => {
        return putLoyaltyActionsAdminActionid(
          {url: `/loyalty-actions/admin/${actionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: actionUpdate
    },
          );
        }, [putLoyaltyActionsAdminActionid])
      }
    


export const usePutLoyaltyActionsAdminActionidMutationOptions = <TError = string | string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutLoyaltyActionsAdminActionidHook>>>, TError,{actionId: string;data: ActionUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutLoyaltyActionsAdminActionidHook>>>, TError,{actionId: string;data: ActionUpdate}, TContext> => {

const mutationKey = ['putLoyaltyActionsAdminActionid'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putLoyaltyActionsAdminActionid =  usePutLoyaltyActionsAdminActionidHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutLoyaltyActionsAdminActionidHook>>>, {actionId: string;data: ActionUpdate}> = (props) => {
          const {actionId,data} = props ?? {};

          return  putLoyaltyActionsAdminActionid(actionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutLoyaltyActionsAdminActionidMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutLoyaltyActionsAdminActionidHook>>>>
    export type PutLoyaltyActionsAdminActionidMutationBody = ActionUpdate
    export type PutLoyaltyActionsAdminActionidMutationError = string | string | string

    export const usePutLoyaltyActionsAdminActionid = <TError = string | string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutLoyaltyActionsAdminActionidHook>>>, TError,{actionId: string;data: ActionUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutLoyaltyActionsAdminActionidHook>>>,
        TError,
        {actionId: string;data: ActionUpdate},
        TContext
      > => {

      const mutationOptions = usePutLoyaltyActionsAdminActionidMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteLoyaltyActionsAdminActionidHook = () => {
        const deleteLoyaltyActionsAdminActionid = useMutator<null>();

        return useCallback((
    actionId: string,
 ) => {
        return deleteLoyaltyActionsAdminActionid(
          {url: `/loyalty-actions/admin/${actionId}`, method: 'DELETE'
    },
          );
        }, [deleteLoyaltyActionsAdminActionid])
      }
    


export const useDeleteLoyaltyActionsAdminActionidMutationOptions = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteLoyaltyActionsAdminActionidHook>>>, TError,{actionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteLoyaltyActionsAdminActionidHook>>>, TError,{actionId: string}, TContext> => {

const mutationKey = ['deleteLoyaltyActionsAdminActionid'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteLoyaltyActionsAdminActionid =  useDeleteLoyaltyActionsAdminActionidHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteLoyaltyActionsAdminActionidHook>>>, {actionId: string}> = (props) => {
          const {actionId} = props ?? {};

          return  deleteLoyaltyActionsAdminActionid(actionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteLoyaltyActionsAdminActionidMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteLoyaltyActionsAdminActionidHook>>>>
    
    export type DeleteLoyaltyActionsAdminActionidMutationError = string | string

    export const useDeleteLoyaltyActionsAdminActionid = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteLoyaltyActionsAdminActionidHook>>>, TError,{actionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteLoyaltyActionsAdminActionidHook>>>,
        TError,
        {actionId: string},
        TContext
      > => {

      const mutationOptions = useDeleteLoyaltyActionsAdminActionidMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetAdminActionsActionidHook = () => {
        const getAdminActionsActionid = useMutator<ActionAdminDetails>();

        return useCallback((
    actionId: string,
 signal?: AbortSignal
) => {
        return getAdminActionsActionid(
          {url: `/admin/actions/${actionId}`, method: 'GET', signal
    },
          );
        }, [getAdminActionsActionid])
      }
    

export const getGetAdminActionsActionidQueryKey = (actionId?: string,) => {
    return [`/admin/actions/${actionId}`] as const;
    }

    
export const useGetAdminActionsActionidQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>, TError = string | string>(actionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminActionsActionidQueryKey(actionId);

  const getAdminActionsActionid =  useGetAdminActionsActionidHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>> = ({ signal }) => getAdminActionsActionid(actionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(actionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminActionsActionidQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>>
export type GetAdminActionsActionidQueryError = string | string


export function useGetAdminActionsActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>, TError = string | string>(
 actionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminActionsActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>, TError = string | string>(
 actionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminActionsActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>, TError = string | string>(
 actionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminActionsActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>, TError = string | string>(
 actionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminActionsActionidHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAdminActionsActionidQueryOptions(actionId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePutAdminActionsActionidHook = () => {
        const putAdminActionsActionid = useMutator<ActionAdminDetails>();

        return useCallback((
    actionId: string,
    actionUpdate: ActionUpdate,
 ) => {
        return putAdminActionsActionid(
          {url: `/admin/actions/${actionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: actionUpdate
    },
          );
        }, [putAdminActionsActionid])
      }
    


export const usePutAdminActionsActionidMutationOptions = <TError = string | string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutAdminActionsActionidHook>>>, TError,{actionId: string;data: ActionUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutAdminActionsActionidHook>>>, TError,{actionId: string;data: ActionUpdate}, TContext> => {

const mutationKey = ['putAdminActionsActionid'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putAdminActionsActionid =  usePutAdminActionsActionidHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutAdminActionsActionidHook>>>, {actionId: string;data: ActionUpdate}> = (props) => {
          const {actionId,data} = props ?? {};

          return  putAdminActionsActionid(actionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminActionsActionidMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutAdminActionsActionidHook>>>>
    export type PutAdminActionsActionidMutationBody = ActionUpdate
    export type PutAdminActionsActionidMutationError = string | string | string

    export const usePutAdminActionsActionid = <TError = string | string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutAdminActionsActionidHook>>>, TError,{actionId: string;data: ActionUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutAdminActionsActionidHook>>>,
        TError,
        {actionId: string;data: ActionUpdate},
        TContext
      > => {

      const mutationOptions = usePutAdminActionsActionidMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteAdminActionsActionidHook = () => {
        const deleteAdminActionsActionid = useMutator<null>();

        return useCallback((
    actionId: string,
 ) => {
        return deleteAdminActionsActionid(
          {url: `/admin/actions/${actionId}`, method: 'DELETE'
    },
          );
        }, [deleteAdminActionsActionid])
      }
    


export const useDeleteAdminActionsActionidMutationOptions = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAdminActionsActionidHook>>>, TError,{actionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAdminActionsActionidHook>>>, TError,{actionId: string}, TContext> => {

const mutationKey = ['deleteAdminActionsActionid'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteAdminActionsActionid =  useDeleteAdminActionsActionidHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteAdminActionsActionidHook>>>, {actionId: string}> = (props) => {
          const {actionId} = props ?? {};

          return  deleteAdminActionsActionid(actionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminActionsActionidMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteAdminActionsActionidHook>>>>
    
    export type DeleteAdminActionsActionidMutationError = string | string

    export const useDeleteAdminActionsActionid = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAdminActionsActionidHook>>>, TError,{actionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteAdminActionsActionidHook>>>,
        TError,
        {actionId: string},
        TContext
      > => {

      const mutationOptions = useDeleteAdminActionsActionidMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetLoyaltyActionsStatusHook = () => {
        const getLoyaltyActionsStatus = useMutator<ActionsEnabled>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getLoyaltyActionsStatus(
          {url: `/loyalty-actions/status`, method: 'GET', signal
    },
          );
        }, [getLoyaltyActionsStatus])
      }
    

export const getGetLoyaltyActionsStatusQueryKey = () => {
    return [`/loyalty-actions/status`] as const;
    }

    
export const useGetLoyaltyActionsStatusQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>, TError = string | string>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoyaltyActionsStatusQueryKey();

  const getLoyaltyActionsStatus =  useGetLoyaltyActionsStatusHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>> = ({ signal }) => getLoyaltyActionsStatus(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoyaltyActionsStatusQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>>
export type GetLoyaltyActionsStatusQueryError = string | string


export function useGetLoyaltyActionsStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>, TError = string | string>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyActionsStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>, TError = string | string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyActionsStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>, TError = string | string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLoyaltyActionsStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>, TError = string | string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLoyaltyActionsStatusQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetActionsStatusHook = () => {
        const getActionsStatus = useMutator<ActionsEnabled>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getActionsStatus(
          {url: `/actions/status`, method: 'GET', signal
    },
          );
        }, [getActionsStatus])
      }
    

export const getGetActionsStatusQueryKey = () => {
    return [`/actions/status`] as const;
    }

    
export const useGetActionsStatusQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>, TError = string | string>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActionsStatusQueryKey();

  const getActionsStatus =  useGetActionsStatusHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>> = ({ signal }) => getActionsStatus(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActionsStatusQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>>
export type GetActionsStatusQueryError = string | string


export function useGetActionsStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>, TError = string | string>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActionsStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>, TError = string | string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActionsStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>, TError = string | string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActionsStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>, TError = string | string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetActionsStatusQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostLoyaltyActionsActionidSubscribeHook = () => {
        const postLoyaltyActionsActionidSubscribe = useMutator<null>();

        return useCallback((
    actionId: string,
    subscribeRequest?: SubscribeRequest,
 signal?: AbortSignal
) => {
        return postLoyaltyActionsActionidSubscribe(
          {url: `/loyalty-actions/${actionId}/subscribe`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: subscribeRequest, signal
    },
          );
        }, [postLoyaltyActionsActionidSubscribe])
      }
    


export const usePostLoyaltyActionsActionidSubscribeMutationOptions = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostLoyaltyActionsActionidSubscribeHook>>>, TError,{actionId: string;data: SubscribeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostLoyaltyActionsActionidSubscribeHook>>>, TError,{actionId: string;data: SubscribeRequest}, TContext> => {

const mutationKey = ['postLoyaltyActionsActionidSubscribe'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postLoyaltyActionsActionidSubscribe =  usePostLoyaltyActionsActionidSubscribeHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostLoyaltyActionsActionidSubscribeHook>>>, {actionId: string;data: SubscribeRequest}> = (props) => {
          const {actionId,data} = props ?? {};

          return  postLoyaltyActionsActionidSubscribe(actionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostLoyaltyActionsActionidSubscribeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostLoyaltyActionsActionidSubscribeHook>>>>
    export type PostLoyaltyActionsActionidSubscribeMutationBody = SubscribeRequest
    export type PostLoyaltyActionsActionidSubscribeMutationError = string | string

    export const usePostLoyaltyActionsActionidSubscribe = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostLoyaltyActionsActionidSubscribeHook>>>, TError,{actionId: string;data: SubscribeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostLoyaltyActionsActionidSubscribeHook>>>,
        TError,
        {actionId: string;data: SubscribeRequest},
        TContext
      > => {

      const mutationOptions = usePostLoyaltyActionsActionidSubscribeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const usePostActionsActionidSubscribeHook = () => {
        const postActionsActionidSubscribe = useMutator<null>();

        return useCallback((
    actionId: string,
    subscribeRequest?: SubscribeRequest,
 signal?: AbortSignal
) => {
        return postActionsActionidSubscribe(
          {url: `/actions/${actionId}/subscribe`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: subscribeRequest, signal
    },
          );
        }, [postActionsActionidSubscribe])
      }
    


export const usePostActionsActionidSubscribeMutationOptions = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostActionsActionidSubscribeHook>>>, TError,{actionId: string;data: SubscribeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostActionsActionidSubscribeHook>>>, TError,{actionId: string;data: SubscribeRequest}, TContext> => {

const mutationKey = ['postActionsActionidSubscribe'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postActionsActionidSubscribe =  usePostActionsActionidSubscribeHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostActionsActionidSubscribeHook>>>, {actionId: string;data: SubscribeRequest}> = (props) => {
          const {actionId,data} = props ?? {};

          return  postActionsActionidSubscribe(actionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostActionsActionidSubscribeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostActionsActionidSubscribeHook>>>>
    export type PostActionsActionidSubscribeMutationBody = SubscribeRequest
    export type PostActionsActionidSubscribeMutationError = string | string

    export const usePostActionsActionidSubscribe = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostActionsActionidSubscribeHook>>>, TError,{actionId: string;data: SubscribeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostActionsActionidSubscribeHook>>>,
        TError,
        {actionId: string;data: SubscribeRequest},
        TContext
      > => {

      const mutationOptions = usePostActionsActionidSubscribeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetLoyaltyActionsActionidHook = () => {
        const getLoyaltyActionsActionid = useMutator<ActionDetail>();

        return useCallback((
    actionId: string,
    params?: GetLoyaltyActionsActionidParams,
 signal?: AbortSignal
) => {
        return getLoyaltyActionsActionid(
          {url: `/loyalty-actions/${actionId}`, method: 'GET',
        params, signal
    },
          );
        }, [getLoyaltyActionsActionid])
      }
    

export const getGetLoyaltyActionsActionidQueryKey = (actionId?: string,
    params?: GetLoyaltyActionsActionidParams,) => {
    return [`/loyalty-actions/${actionId}`, ...(params ? [params]: [])] as const;
    }

    
export const useGetLoyaltyActionsActionidQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>, TError = string | string>(actionId: string,
    params?: GetLoyaltyActionsActionidParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoyaltyActionsActionidQueryKey(actionId,params);

  const getLoyaltyActionsActionid =  useGetLoyaltyActionsActionidHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>> = ({ signal }) => getLoyaltyActionsActionid(actionId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(actionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoyaltyActionsActionidQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>>
export type GetLoyaltyActionsActionidQueryError = string | string


export function useGetLoyaltyActionsActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>, TError = string | string>(
 actionId: string,
    params: undefined |  GetLoyaltyActionsActionidParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyActionsActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>, TError = string | string>(
 actionId: string,
    params?: GetLoyaltyActionsActionidParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyActionsActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>, TError = string | string>(
 actionId: string,
    params?: GetLoyaltyActionsActionidParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLoyaltyActionsActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>, TError = string | string>(
 actionId: string,
    params?: GetLoyaltyActionsActionidParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsActionidHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLoyaltyActionsActionidQueryOptions(actionId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetActionsActionidHook = () => {
        const getActionsActionid = useMutator<ActionDetail>();

        return useCallback((
    actionId: string,
    params?: GetActionsActionidParams,
 signal?: AbortSignal
) => {
        return getActionsActionid(
          {url: `/actions/${actionId}`, method: 'GET',
        params, signal
    },
          );
        }, [getActionsActionid])
      }
    

export const getGetActionsActionidQueryKey = (actionId?: string,
    params?: GetActionsActionidParams,) => {
    return [`/actions/${actionId}`, ...(params ? [params]: [])] as const;
    }

    
export const useGetActionsActionidQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>, TError = string | string>(actionId: string,
    params?: GetActionsActionidParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActionsActionidQueryKey(actionId,params);

  const getActionsActionid =  useGetActionsActionidHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>> = ({ signal }) => getActionsActionid(actionId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(actionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActionsActionidQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>>
export type GetActionsActionidQueryError = string | string


export function useGetActionsActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>, TError = string | string>(
 actionId: string,
    params: undefined |  GetActionsActionidParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActionsActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>, TError = string | string>(
 actionId: string,
    params?: GetActionsActionidParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActionsActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>, TError = string | string>(
 actionId: string,
    params?: GetActionsActionidParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActionsActionid<TData = Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>, TError = string | string>(
 actionId: string,
    params?: GetActionsActionidParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsActionidHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetActionsActionidQueryOptions(actionId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetLoyaltyActionsHook = () => {
        const getLoyaltyActions = useMutator<ActionDetail[]>();

        return useCallback((
    params?: GetLoyaltyActionsParams,
 signal?: AbortSignal
) => {
        return getLoyaltyActions(
          {url: `/loyalty-actions`, method: 'GET',
        params, signal
    },
          );
        }, [getLoyaltyActions])
      }
    

export const getGetLoyaltyActionsQueryKey = (params?: GetLoyaltyActionsParams,) => {
    return [`/loyalty-actions`, ...(params ? [params]: [])] as const;
    }

    
export const useGetLoyaltyActionsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>, TError = string | string>(params?: GetLoyaltyActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoyaltyActionsQueryKey(params);

  const getLoyaltyActions =  useGetLoyaltyActionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>> = ({ signal }) => getLoyaltyActions(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoyaltyActionsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>>
export type GetLoyaltyActionsQueryError = string | string


export function useGetLoyaltyActions<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>, TError = string | string>(
 params: undefined |  GetLoyaltyActionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyActions<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>, TError = string | string>(
 params?: GetLoyaltyActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyActions<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>, TError = string | string>(
 params?: GetLoyaltyActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLoyaltyActions<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>, TError = string | string>(
 params?: GetLoyaltyActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltyActionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLoyaltyActionsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetActionsHook = () => {
        const getActions = useMutator<ActionDetail[]>();

        return useCallback((
    params?: GetActionsParams,
 signal?: AbortSignal
) => {
        return getActions(
          {url: `/actions`, method: 'GET',
        params, signal
    },
          );
        }, [getActions])
      }
    

export const getGetActionsQueryKey = (params?: GetActionsParams,) => {
    return [`/actions`, ...(params ? [params]: [])] as const;
    }

    
export const useGetActionsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>, TError = string | string>(params?: GetActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActionsQueryKey(params);

  const getActions =  useGetActionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>> = ({ signal }) => getActions(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActionsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>>
export type GetActionsQueryError = string | string


export function useGetActions<TData = Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>, TError = string | string>(
 params: undefined |  GetActionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActions<TData = Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>, TError = string | string>(
 params?: GetActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActions<TData = Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>, TError = string | string>(
 params?: GetActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActions<TData = Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>, TError = string | string>(
 params?: GetActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetActionsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetLoyaltySettingsOptInHook = () => {
        const getLoyaltySettingsOptIn = useMutator<UserOptInSettings>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getLoyaltySettingsOptIn(
          {url: `/loyalty-settings/opt-in`, method: 'GET', signal
    },
          );
        }, [getLoyaltySettingsOptIn])
      }
    

export const getGetLoyaltySettingsOptInQueryKey = () => {
    return [`/loyalty-settings/opt-in`] as const;
    }

    
export const useGetLoyaltySettingsOptInQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>, TError = string | string>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoyaltySettingsOptInQueryKey();

  const getLoyaltySettingsOptIn =  useGetLoyaltySettingsOptInHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>> = ({ signal }) => getLoyaltySettingsOptIn(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoyaltySettingsOptInQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>>
export type GetLoyaltySettingsOptInQueryError = string | string


export function useGetLoyaltySettingsOptIn<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>, TError = string | string>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltySettingsOptIn<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>, TError = string | string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltySettingsOptIn<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>, TError = string | string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLoyaltySettingsOptIn<TData = Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>, TError = string | string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoyaltySettingsOptInHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLoyaltySettingsOptInQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePutLoyaltySettingsOptInHook = () => {
        const putLoyaltySettingsOptIn = useMutator<UserOptInSettings>();

        return useCallback((
    userOptInSettings: UserOptInSettings,
 ) => {
        return putLoyaltySettingsOptIn(
          {url: `/loyalty-settings/opt-in`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userOptInSettings
    },
          );
        }, [putLoyaltySettingsOptIn])
      }
    


export const usePutLoyaltySettingsOptInMutationOptions = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutLoyaltySettingsOptInHook>>>, TError,{data: UserOptInSettings}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutLoyaltySettingsOptInHook>>>, TError,{data: UserOptInSettings}, TContext> => {

const mutationKey = ['putLoyaltySettingsOptIn'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putLoyaltySettingsOptIn =  usePutLoyaltySettingsOptInHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutLoyaltySettingsOptInHook>>>, {data: UserOptInSettings}> = (props) => {
          const {data} = props ?? {};

          return  putLoyaltySettingsOptIn(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutLoyaltySettingsOptInMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutLoyaltySettingsOptInHook>>>>
    export type PutLoyaltySettingsOptInMutationBody = UserOptInSettings
    export type PutLoyaltySettingsOptInMutationError = string | string

    export const usePutLoyaltySettingsOptIn = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutLoyaltySettingsOptInHook>>>, TError,{data: UserOptInSettings}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutLoyaltySettingsOptInHook>>>,
        TError,
        {data: UserOptInSettings},
        TContext
      > => {

      const mutationOptions = usePutLoyaltySettingsOptInMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetSettingsOptInHook = () => {
        const getSettingsOptIn = useMutator<UserOptInSettings>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getSettingsOptIn(
          {url: `/settings/opt-in`, method: 'GET', signal
    },
          );
        }, [getSettingsOptIn])
      }
    

export const getGetSettingsOptInQueryKey = () => {
    return [`/settings/opt-in`] as const;
    }

    
export const useGetSettingsOptInQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>, TError = string | string>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingsOptInQueryKey();

  const getSettingsOptIn =  useGetSettingsOptInHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>> = ({ signal }) => getSettingsOptIn(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsOptInQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>>
export type GetSettingsOptInQueryError = string | string


export function useGetSettingsOptIn<TData = Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>, TError = string | string>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsOptIn<TData = Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>, TError = string | string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsOptIn<TData = Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>, TError = string | string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSettingsOptIn<TData = Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>, TError = string | string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSettingsOptInHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetSettingsOptInQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePutSettingsOptInHook = () => {
        const putSettingsOptIn = useMutator<UserOptInSettings>();

        return useCallback((
    userOptInSettings: UserOptInSettings,
 ) => {
        return putSettingsOptIn(
          {url: `/settings/opt-in`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userOptInSettings
    },
          );
        }, [putSettingsOptIn])
      }
    


export const usePutSettingsOptInMutationOptions = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutSettingsOptInHook>>>, TError,{data: UserOptInSettings}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutSettingsOptInHook>>>, TError,{data: UserOptInSettings}, TContext> => {

const mutationKey = ['putSettingsOptIn'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putSettingsOptIn =  usePutSettingsOptInHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutSettingsOptInHook>>>, {data: UserOptInSettings}> = (props) => {
          const {data} = props ?? {};

          return  putSettingsOptIn(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutSettingsOptInMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutSettingsOptInHook>>>>
    export type PutSettingsOptInMutationBody = UserOptInSettings
    export type PutSettingsOptInMutationError = string | string

    export const usePutSettingsOptIn = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutSettingsOptInHook>>>, TError,{data: UserOptInSettings}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutSettingsOptInHook>>>,
        TError,
        {data: UserOptInSettings},
        TContext
      > => {

      const mutationOptions = usePutSettingsOptInMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetMarketingSettingsHook = () => {
        const getMarketingSettings = useMutator<UpdateMarketingSetting>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getMarketingSettings(
          {url: `/marketing-settings`, method: 'GET', signal
    },
          );
        }, [getMarketingSettings])
      }
    

export const getGetMarketingSettingsQueryKey = () => {
    return [`/marketing-settings`] as const;
    }

    
export const useGetMarketingSettingsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>, TError = string | string>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingSettingsQueryKey();

  const getMarketingSettings =  useGetMarketingSettingsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>> = ({ signal }) => getMarketingSettings(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketingSettingsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>>
export type GetMarketingSettingsQueryError = string | string


export function useGetMarketingSettings<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>, TError = string | string>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingSettings<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>, TError = string | string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingSettings<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>, TError = string | string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMarketingSettings<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>, TError = string | string>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingSettingsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetMarketingSettingsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePutMarketingSettingsHook = () => {
        const putMarketingSettings = useMutator<UpdateMarketingSetting>();

        return useCallback((
    updateMarketingSetting: UpdateMarketingSetting,
 ) => {
        return putMarketingSettings(
          {url: `/marketing-settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMarketingSetting
    },
          );
        }, [putMarketingSettings])
      }
    


export const usePutMarketingSettingsMutationOptions = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutMarketingSettingsHook>>>, TError,{data: UpdateMarketingSetting}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutMarketingSettingsHook>>>, TError,{data: UpdateMarketingSetting}, TContext> => {

const mutationKey = ['putMarketingSettings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putMarketingSettings =  usePutMarketingSettingsHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutMarketingSettingsHook>>>, {data: UpdateMarketingSetting}> = (props) => {
          const {data} = props ?? {};

          return  putMarketingSettings(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutMarketingSettingsMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutMarketingSettingsHook>>>>
    export type PutMarketingSettingsMutationBody = UpdateMarketingSetting
    export type PutMarketingSettingsMutationError = string | string

    export const usePutMarketingSettings = <TError = string | string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutMarketingSettingsHook>>>, TError,{data: UpdateMarketingSetting}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutMarketingSettingsHook>>>,
        TError,
        {data: UpdateMarketingSetting},
        TContext
      > => {

      const mutationOptions = usePutMarketingSettingsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
